//地理位置处理
import jsonPloader from "If_AdTool/common/JsonpLoader";
import sdkTool from "If_AdTool/common/sdkTool";
const URL = "https://region.ifeng.com/get?format=js";
let region =  {
    init:function(){
        if (typeof (regionOrientProv) == 'undefined') {
            let regionVer = '1.2';
            //get the region cookie
            let regionOrientProv = sdkTool.cookie('prov');
            let regionOrientCity = sdkTool.cookie('city');
            let regionOrientWeatherCity = sdkTool.cookie('weather_city');
            let regionOrientIP = sdkTool.cookie('region_ip');
            let regionOrientVersion = sdkTool.cookie('region_ver');
            //If there isn't region version cookie value, get the values and then set them in cookie
            if (typeof (regionOrientVersion) == null || regionOrientVersion == 'undefined' || regionOrientVersion == '' || regionOrientVersion != regionVer) {
                jsonPloader.getJsonP(URL, "callback", (locationStr) => {
                    let COOKIE_EXPIRES = 43200;
                    let regionArray = locationStr.split("[");
                    let regionStr = regionArray[0].slice(0, -1);
                    let regionTempArray = regionStr.split("_");
                    let regionProv = regionTempArray[0];
                    let regionCity = regionTempArray[1];
                    let regionWeatherCity = regionArray[1].slice(0, -1);
                    let regionIP = regionArray[2].slice(0, -1);
                    regionIP = regionIP.substring(0, regionIP.lastIndexOf(".")) + ".x";
                    //{expires: 7, path: ‘/’, domain: ‘jquery.com’, secure: true}
                    sdkTool.cookie('prov', regionProv, {
                        expires: COOKIE_EXPIRES
                    });
                    sdkTool.cookie('city', regionCity, {
                        expires: COOKIE_EXPIRES
                    });
                    sdkTool.cookie('weather_city', regionWeatherCity, {
                        expires: COOKIE_EXPIRES
                    });
                    sdkTool.cookie('region_ip', regionIP, {
                        expires: COOKIE_EXPIRES
                    });
                    sdkTool.cookie('region_ver', regionVer, {
                        expires: COOKIE_EXPIRES
                    });
                })
            } else {}

        }
    }
}
export default region;